import { Component, OnInit } from '@angular/core';
import { IEpGridModel, IEpGridSelectionOptions, IEpComponentEventArg, EpEventService, EpGridEditMode, IEpGridColumn, IEpGridEditState } from '@epicor/kinetic';
import { EpbtFaLabelsService } from '../../services/epbt-fa-labels.service';
import { LabelTemplateQty } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { Router } from '@angular/router';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-label-summary-templates-grid',
  templateUrl: './epbt-fa-label-summary-templates-grid.component.html',
  styleUrls: ['./epbt-fa-label-summary-templates-grid.component.scss']
})
export class EpbtFaLabelSummaryTemplatesGridComponent implements OnInit {

  public gridModel: IEpGridModel;
  templateList: any[];
  constructor(private labelService: EpbtFaLabelsService, public epEvent: EpEventService, private faService: EpbtFieldAgentService, private router: Router, ) { }

  ngOnInit() {
    this.gridModel = this.getGridModel();
    this.bindLabelTemplates();
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      columns: [
        { field: 'name', title: 'NAME', width: 100, hidden: false, editable: false },
        { field: 'kind', title: 'TYPE', width: 100, hidden: false, editable: false },
        { field: 'requestedQuantity', title: 'QTY', width: 60, hidden: false, editable: false },
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToLabelTemplates();
        }
      },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // grid height calculation start
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 550; // 399
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    return height > 230 ? height : 240;
  }



  updateLabelSummaryTemplateGridData() {
    this.bindLabelTemplates();
    // this.gridModel.data = this.labelService.labelsRequest.templates.slice();
  }


  bindLabelTemplates() {
    const result = this.labelService.labelsRequest.templates.filter(qty => qty.requestedQuantity > 0);
    this.templateList = [];
    // this.labelService.labelsRequest.templates = result;
    result.forEach(x => {
      this.templateList.push({ requestedQuantity: x.requestedQuantity, name: x.name, kind: x.kind });
    });
    this.gridModel.data = this.templateList;
  }

  navigateToLabelTemplates() {
    this.epEvent.broadcast(CustomEvents.LabelTemplatesSummaryClick, 0);
  }

  onCardClick(model) {
    this.navigateToLabelTemplates();
  }

}
